import type { Client, RequestContext } from "../client";
import type { DashboardConfigurationResource } from "../resources/dashboardConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";

export class DashboardConfigurationRepository extends ConfigurationRepository<DashboardConfigurationResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("DashboardConfiguration", client, requestContext);
    }
}
